import {Component} from "react";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  TextField as MTextField
} from "@material-ui/core";
import {
  Labeled, ReferenceManyField,
  refreshView as refreshViewAction,
  showNotification as showNotificationAction,
  Datagrid, TextField
} from "react-admin";
import $ from "jquery";
import {get} from "./authProvider";
import React from "react";
import { connect } from 'react-redux';
import { authCardStyle } from "./auth";

function MembershipId(props) {
  return <span>{props.record.membership_id}</span>;
}

class MVaultDisconnectButton extends Component {
  deactivate(membershipId, uuid) {
    $.ajax('/api/v1/mvault/deactivate',
      {
        method: 'POST',
        data: { membershipId, uuid },
        headers: {
          Authorization: 'Bearer ' + get()
        }
      }
    ).then(() => {
      this.props.showNotification('Deactivation successful');
    }).catch((err) => {
      let message = err.responseText && err.responseText !== '' ? err.responseText : 'An error occurred during the deactivation.';

      if (err.status === 422) {
        let responseMsg = JSON.parse(err.responseText);
        message = '';
        for (var key in responseMsg) {
          message += responseMsg[key] + " ";
        }
      }
      this.props.showNotification(message);
    }).always(() => {
      this.props.refreshView();
    });
  }

  render() {
    return <Button
      variant="contained"
      color="primary"
      onClick={() => this.deactivate(this.props.record.membership_id, this.props.uuid)}>
      Deactivate
    </Button>;
  }
}

let ConnectedMVaultDisconnectButton = connect(null, { refreshView: refreshViewAction, showNotification: showNotificationAction })(MVaultDisconnectButton);

class MVaultRecords extends Component {
  buildData() {
    let mvaultRecords = this.props.data[this.props.ids[0]] ? this.props.data[this.props.ids[0]].data : [];

    let ids = mvaultRecords.map((record, i) => `${record.membership_id}-${i}`);
    let data = {};

    ids.forEach((key, i) => {
      data[key] = mvaultRecords[i];
    });

    return Object.assign({}, this.props, {ids, data});
  }

  render() {
    if (!this.props.ids) {
      return null;
    }

    let { uuid, ...rest } = this.buildData();

    if (rest.ids.length === 0) {
      return null;
    }

    return <div>
      <div>Activated MVault Records</div>
      <Datagrid {...rest}>
        <MembershipId label="MVault Membership Id" />
        <ConnectedMVaultDisconnectButton uuid={uuid} label="Remove" />
      </Datagrid>
    </div>;
  }
}

class MVaultEnabler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.runMVaultAssociation = this.runMVaultAssociation.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  runMVaultDissociation() {
    let mvaultDataIds = (this.props.ids || []).filter(id => {
      return this.props.data[id].label === 'mvault';
    });

    $.ajax('/api/v1/job/mvault/dissociate-membership?mode=sync',
      {
        method: 'POST',
        data: {
          uuid: this.props.uuid,
          membershipId: this.props.data[mvaultDataIds[0]].data.membership_id
        },
        headers: {
          Authorization: 'Bearer ' + get()
        }
      }
    ).then(() => {
      this.props.showNotification('Dissociation successful!');
    }).catch((err) => {
      let message = err.responseText && err.responseText !== '' ? JSON.parse(err.responseText).message : 'An error occurred during the dissociation.';

      if (err.status === 422) {
        let responseMsg = JSON.parse(err.responseText);
        message = '';
        for (let key in responseMsg) {
          message += responseMsg[key] + " ";
        }
      }
      this.props.showNotification(message);
    }).always(() => {
      this.props.refreshView();
    });
  }

  runMVaultAssociation() {
    $.ajax('/api/v1/job/mvault/associate-membership?mode=sync',
      {
        method: 'POST',
        data: {
          uuid: this.props.uuid,
          membershipId: this.state.value,
        },
        headers: {
          Authorization: 'Bearer ' + get()
        }
      }
    ).then(() => {
      this.props.showNotification('Association successful!');
    }).catch((err) => {
      let message = err.responseText && err.responseText !== '' ? err.responseText : 'An error occurred during the association.';

      if (err.status === 422) {
        let responseMsg = JSON.parse(err.responseText);
        message = '';
        for (var key in responseMsg) {
          message += responseMsg[key] + " ";
        }
      }
      this.props.showNotification(message);
    }).always(() => {
      this.props.refreshView();
    });
  }

  render() {
    let mvaultDataIds = (this.props.ids || []).filter(id => {
      return this.props.data[id].label === 'mvault';
    });

    if (mvaultDataIds.length > 0) {
      return <div style={{marginBottom: '32px'}}>
        Currently associated to {this.props.data[mvaultDataIds[0]].data.membership_id}
        <br/>
        <Button variant="contained" color="primary" onClick={this.runMVaultDissociation.bind(this)}>Dissociate</Button>
      </div>;
    }

    return <div style={{marginBottom: '32px'}}>
      <div>Manually associate MVault record</div>
      <Labeled label="MVault Membership Id">
        <MTextField id="mvault-id" onInput={this.handleChange} value={this.state.value} />
      </Labeled>
      <br/>
      <Button variant="contained" color="primary" onClick={this.runMVaultAssociation.bind(this)}>Associate</Button>
    </div>;
  }
}

let ConnectedMVaultEnabler = connect(null, { refreshView: refreshViewAction, showNotification: showNotificationAction })(MVaultEnabler);

class MVaultManager extends Component {
  render() {
    return <Card key="association" style={authCardStyle}>
      <CardHeader title="MVault Association" subheader="Manage associated and activated MVault records" />
      <CardContent>
        <ReferenceManyField filter={{label: 'mvault'}} label={null} reference="info" target="auth_id" {...this.props}>
          <ConnectedMVaultEnabler uuid={this.props.record.uuid} />
        </ReferenceManyField>
        <ReferenceManyField filter={{label: 'mvault_conflict'}} label={null} reference="info" target="auth_id" {...this.props}>
          <MVaultRecords uuid={this.props.record.uuid} />
        </ReferenceManyField>
      </CardContent>
    </Card>;
  }
}

export default MVaultManager;


// WEBPACK FOOTER //
// ./resources/assets/js/MVaultTools.js